<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 表头设置控件 -->
      <!-- <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template> -->
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'declaration',
      breadcrumb: [
        { name: "报单管理" },
        { name: "报单列表" },
      ],
      formCtrl: [
        {
          label: "客户名称",
          keyName: "custom",
          placeholder: "请填写客户名称",
          type: "text",
        },
        // {
        //   label: "提交时间",
        //   keyName: "submitted_at",
        //   placeholder: "请选择提交时间",
        //   type: "daterange",
        //   options: [],
        // },
      ],
      searchDateOptions: [
        {
          label: "提交时间",
          keyName: "submitted_at",
          placeholder: "请选择提交时间",
          type: "daterange",
          options: [],
        },
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      cols: [
        { keyName: "custom", label: "客户名称", minwidth: 120 },
        { keyName: "product", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "quantity", label: "下单量", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "submitted_at", label: "提交日期", minwidth: 120 },
        // { keyName: "nickname", label: "操作人", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            this.$router.push(
              `/reportOrder/detail?id=${id}&mode=view`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/reportOrder/detail?id=${id}&mode=edit`)
          },
        },
        {
          class: 'dispatchbtn',
          title: '派单',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ c_id, id }) => {
            this.$router.push(`/reportOrder/dispatch?c_id=${c_id}&r_id=${id}`)
          },
        },
        {
          title: '创建合同',
          img: require('@/assets/img/icon_creat_contract.png'),
          unimg: require('@/assets/img/icon_creat_contract_hover.png'),
          cb: ({ c_id, id }) => {
            this.$router.push(`/reportOrder/addContract?c_id=${c_id}&r_id=${id}`)
          },
        },
      ],
      // baseParams: [''],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          // obj.DISABLED = !(obj.inspection_at)
          // console.log({ ...obj })
          return obj
        })
      }
      // console.log(this.tableData)
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>